<template>
  <div id="contenedor-eliminar-tipo-infraestructura">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar tipo de infraestructura </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el tipo de infraestructura? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarTipoInfraestructura"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixTiposInfraestructura from './mixTiposInfraestructura';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarTipoInfraestructura',
  mixins: [mixTiposInfraestructura],
  props: {
    tipoInfraestructuraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
